

import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import { put, takeLatest } from "redux-saga/effects";
import { getUserByToken, getUserPermissions } from "./authCrud";

export const actionTypes = {
  Login: "[Login] Action",
  Logout: "[Logout] Action",
  Register: "[Register] Action",
  UserRequested: "[Request User] Action",
  UserPermissionsRequested: "[Request User Permissions] Action",
  UserLoaded: "[Load User] Auth API",
  SetUser: "[Set User] Action",
  UserPermissionsLoaded:"[ User Permissions Loaded] Action",
};

const initialAuthState = {
  user: undefined,
  authToken: undefined,
  userPermissions: undefined,
};

export const reducer = persistReducer(
  { storage, key: "v713-demo1-auth", whitelist: ["user", "authToken","bookingsCC", "dashboardData"] },
  (state = initialAuthState, action) => {
	console.error(action);
    switch (action.type) {
      case actionTypes.Login: {
        const { authToken } = action.payload;

        return { authToken, user: undefined };
      }

      case actionTypes.Register: {
        const { authToken } = action.payload;

        return { authToken, user: undefined };
      }

      case actionTypes.Logout: {
        // TODO: Change this code. Actions in reducer aren't allowed.
        return initialAuthState;
      }
      case actionTypes.UserLoaded: {
        const { user, authToken } = action.payload;
		if (!authToken) {
			return { ...state, user};
	    }
		return { ...state, user, authToken };
      }
      case actionTypes.UserPermissionsLoaded: {
        const { userPermissions } = action.payload;
        return { ...state, userPermissions };
      }

      case actionTypes.SetUser: {
        const { user } = action.payload;
        return { ...state, user };
      }

      default:
        return state;
    }
  }
);

export const actions = {
  login: (authToken) => ({ type: actionTypes.Login, payload: { authToken } }),
  register: (authToken) => ({
    type: actionTypes.Register,
    payload: { authToken },
  }),
  logout: () => ({ type: actionTypes.Logout }),
  requestUser: (user) => ({
    type: actionTypes.UserRequested,
    payload: { user },
  }),
  requestUserPermissions: (user) => ({
    type: actionTypes.UserPermissionsRequested,
    payload: {},
  }),
  fulfillUser: (user, authToken = null) => ({ type: actionTypes.UserLoaded, payload: { user : user, authToken : authToken } }),
  fulfillUserPermissions: (userPermissions) => ({ type: actionTypes.UserPermissionsLoaded, payload: { userPermissions } }),

  setUser: (user) => ({ type: actionTypes.SetUser, payload: { user } }),
};

export function* saga() {
  // yield takeLatest(actionTypes.Login, function* loginSaga() {
    
  // });

  yield takeLatest(actionTypes.UserLoaded, function* FulfillUser(user) {
    // yield put(actions.requestUser());
    yield put(actions.requestUserPermissions(user));
    // yield put();
  });

  // yield takeLatest(actionTypes.Register, function* registerSaga() {
  //   // yield put(actions.requestUser());
  //   // yield put(actions.requestUserRoles());

  // });

  yield takeLatest(actionTypes.UserRequested, function* userRequested() {
    const { data: user } = yield getUserByToken();

    yield put(actions.fulfillUser(user));
  });

  yield takeLatest(actionTypes.UserPermissionsRequested, function* userPermissionsRequested(user) {
    const { data: permissions } = yield getUserPermissions(user);
    yield put(actions.fulfillUserPermissions(permissions));
  });
}
